document.addEventListener("DOMContentLoaded", function () {
    const shareItems = document.querySelectorAll(".social-share-dropdown");

    if (!shareItems.length) {
        return;
    }

    shareItems.forEach(item => {
        const toggleBtn = item.querySelector(".share-toggle-btn");
        const menu = item.querySelector(".share-menu");

        if (!toggleBtn || !menu) {
            return;
        }

        toggleBtn.addEventListener("click", function (e) {
            e.stopPropagation();

            // Close all other open menus
            document.querySelectorAll(".share-menu.show").forEach(openMenu => {
                if (openMenu !== menu) {
                    openMenu.classList.remove("show");
                }
            });

            // Toggle current menu
            menu.classList.toggle("show");
        });
    });

    // Close all menus when clicking outside
    document.addEventListener("click", function () {
        document.querySelectorAll(".share-menu.show").forEach(menu => {
            menu.classList.remove("show");
        });
    });
});